import React, { useEffect, useState } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Divider,
  Grid,
  //   TextField,
} from "@material-ui/core";
import EquipTypeChart from "./equip-type-chart";
import CircleChart from "./circle-chart";

interface IElectricEquip {
  title: string;
  data: Object;
}

const useStyle = makeStyles((theme: Theme) => ({
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    borderBottom: `solid 1px ${theme.palette.divider}`,
    "& .MuiCardHeader-action": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      height: theme.spacing(4.5),
    },
  },
  headerTitle: { fontFamily: "Montserrat-SemiBold" },
  cardHaft: { height: "100%" },
  cardContent: {
    height: `calc(100% - 45px)`,
    padding: 0,
    "&:last-child": { paddingBottom: 0 },
  },
  barChart: {
    height: `calc(100% - ${theme.spacing(20) + theme.spacing(1)}px)`,
  },
  divider: { margin: theme.spacing(1) },
  circleChart: { height: theme.spacing(20) - theme.spacing(1) },
  gridCircle: {
    height: theme.spacing(15),
    display: "flex",
    flexDirection: "column",
  },
  labelCircle: {
    fontSize: 20,
    textAlign: "center",
    fontFamily: "Montserrat-Medium",
  },
}));

const ElectricEquip = (props: IElectricEquip) => {
  const classes = useStyle();
  const { title, data } = props;
  const [EquipPercent, setEquipPercent] = useState<any>({
    IN: 0,
    RM: 0,
    RP: 0,
    EX: 0,
  });

  useEffect(() => {
    const dataEvent: any = data;
    let DataTemplate = {
      IN: 0,
      RM: 0,
      RP: 0,
      EX: 0,
    };
    dataEvent.workFunc.map((wk: any) => {
      DataTemplate = {
        ...DataTemplate,
        [wk._id.workFunc.substr(0, 2)]: (
          Number(Number(wk.count) * 100) / Number(dataEvent.equip_count)
        ).toFixed(0),
      };
      return null;
    });

    setEquipPercent(DataTemplate);
  }, [data]);
  return (
    <Card className={classes.cardHaft}>
      <CardHeader
        title={
          <Typography variant="subtitle1" className={classes.headerTitle}>
            {title}
          </Typography>
        }
        className={classes.header}
      />
      <CardContent className={classes.cardContent}>
        <div className={classes.barChart}>
          <EquipTypeChart data={data} />
        </div>
        <Divider className={classes.divider} />
        <div className={classes.circleChart}>
          <Grid container>
            <Grid item xs={3} className={classes.gridCircle}>
              <CircleChart name="IN." value={EquipPercent.IN} max={100} />
              <Typography variant="h6" className={classes.labelCircle}>
                IN.
              </Typography>
            </Grid>
            <Grid item xs={3} className={classes.gridCircle}>
              <CircleChart name="IN." value={EquipPercent.RM} max={100} />
              <Typography variant="h6" className={classes.labelCircle}>
                RM.
              </Typography>
            </Grid>
            <Grid item xs={3} className={classes.gridCircle}>
              <CircleChart name="IN." value={EquipPercent.RP} max={100} />
              <Typography variant="h6" className={classes.labelCircle}>
                RP.
              </Typography>
            </Grid>
            <Grid item xs={3} className={classes.gridCircle}>
              <CircleChart name="IN." value={EquipPercent.EX} max={100} />
              <Typography variant="h6" className={classes.labelCircle}>
                EX.
              </Typography>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

export default ElectricEquip;
